import React from "react";
import {Button} from "../common/common";
import {Checkbox, FormInput, ValidateForm} from "../common/formValidation";
import {reduxWrapper} from "../../globalState";

class ProfileViewRender extends React.Component {
	constructor(props) {
			super(props);
			
			this.state = {
				passwords: {},
				user: {}
			};
			
			this.saveUser = val => {
				this.props.apiCall("PUT", "/user/me", data => {
					alert("Saved");
				}, val);
			};

			this.savePass = val => {
				this.props.apiCall("PUT", "/user/me/password", data => {
					alert("Du har nu skiftet dit kodeord");
				}, val);
			};
	}
	
	componentWillMount() {
		this.props.apiCall("GET", "user/me", data => {
			this.setState({user: data});
		})
	}
	
	render() {
		return (
			<div className="myProfileContent">
				<div className="myProfileLeft">
					<ValidateForm values={this.state.user} onChange={val => this.setState({user: val})} onSubmit={this.saveUser}>
						<FormInput name="firstname" title="FORNAVN(E)" req/>
						<FormInput name="lastname" title="EFTERNAVN" req/>
						<FormInput name="email" rules="email" type="email" req/>
						<FormInput name="phone" title="TELEFON" rules="phone"/>
						<Checkbox name="signUpToNewsletter" title="Afmeld nyhedsbrev"/>
						<Button className="btnGreen" submit>GEM PROFIL</Button>
					</ValidateForm>
				</div>
				<div className="myProfileRight">
					<ValidateForm values={this.state.passwords} onChange={val => this.setState({passwords: val})} onSubmit={this.savePass}>
						<FormInput name="oldPassword" title="ADGANGSKODE" type="password" req/>
						<span className="subHead">SKIFT DIN ADGANGSKODE</span>
						<p>Vi foreslår, at du bruger en unik adgangskode - en du ikke bruger andre steder.</p>
						<p>Krav til din nye adgangskode</p>
						<ol>
							<li>
								Din adgangskode skal være mindst 6 tegn
							</li>
							<li>
								Den skal indeholde en kombination af numre og bogstaver
							</li>
							<li>
								Brug ikke dit for- eller efternavn samt fødselsdagsdato
							</li>
						</ol>
						<FormInput name="newPassword" title="NY ADGANGSKODE" password req/>
						<FormInput name="newPasswordRepeat" title="BEKRÆFT ADGANGSKODE" type="password" custom={{
							type: "compare",
							value: this.state.passwords.newPassword || "",
							error: "Dine kodeord matcher ikke"}
						} req/>
						<Button className="btnGreen" submit>GEM ADGANGSKODE</Button>
					</ValidateForm>
				</div>
			</div>
		);
	}
}

const ProfileView = reduxWrapper("getApiCall")(ProfileViewRender);

export default ProfileView;



// WEBPACK FOOTER //
// ./src/components/userPages/profile.js